import { skipToken, useQuery } from "@tanstack/react-query";
import { getMerchantsPublicIDTerminalContractsTerminalContractPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_TERMINAL_CONTRACT_QUERY_KEY = "MERCHANT_TERMINAL_CONTRACT";

export const getMerchantTerminalContractQueryKey = (
  merchantPublicID: string,
  terminalContractPublicID?: string,
) => [
  MERCHANT_TERMINAL_CONTRACT_QUERY_KEY,
  merchantPublicID,
  terminalContractPublicID,
];

export const useGetMerchantTerminalContractQuery = (
  merchantPublicID: string,
  terminalContractPublicID?: string,
  enabled = true,
) =>
  useQuery({
    queryKey: getMerchantTerminalContractQueryKey(
      merchantPublicID,
      terminalContractPublicID,
    ),
    queryFn: terminalContractPublicID
      ? processResponseWithApiProblemDetails(() =>
          getMerchantsPublicIDTerminalContractsTerminalContractPublicID(
            merchantPublicID,
            terminalContractPublicID,
          ),
        )
      : skipToken,
    enabled,
  });
